module.exports = __webpack_public_path__ + "img/logo-whatsapp.6a3988e3.png";